import { messages } from './messages';
/**
 * A service which provides localization methods.
 */
var LocalizationService = /** @class */ (function () {
    function LocalizationService(language) {
        this.language = language;
        if (language === '' && process.env.NODE_ENV !== 'production') {
            throw 'Language should not be an empty string';
        }
    }
    /**
     * Provides a string based on a key for the current language.
     * When no string for the current language is available under this key,
     * the `defaultValue` is returned.
     *
     * @param key - The key which identifies the string for the current language.
     * @param defaultValue - The default value which will be returned when no string
     * for the current language is available under the key.
     * @return - The string for the current language.
     */
    LocalizationService.prototype.toLanguageString = function (key, defaultValue) {
        if (this.language &&
            messages[this.language] &&
            messages[this.language].hasOwnProperty(key)) {
            return messages[this.language][key];
        }
        else if (Object.keys(this)[0] &&
            messages[Object.values(this)[0]] &&
            messages[Object.values(this)[0]].hasOwnProperty(key)) {
            return messages[Object.values(this)[0]][key];
        }
        else {
            return defaultValue;
        }
    };
    return LocalizationService;
}());
export { LocalizationService };



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-intl/dist/es/Localization/LocalizationService.js
// module id = 231
// module chunks = 93